// Lean subset of site-data that the always-loaded components (Header, Hero,
// NorwoodQuiz, Footer) need. Keeping this separate means the bulk of
// site-data.ts (reviews, FAQs, results, doctors) only loads with the
// lazy below-the-fold sections instead of the main bundle.

export const BASE = "https://restorehair.com";

// Right-sized (468x72) WebP of the RESTORE logo; the CDN original is 2017x311.
const logo = "/restore-logo.webp";
import hero__asset from "@/assets/restore/hero.webp.asset.json";
const hero = hero__asset.url;
import play__asset from "@/assets/restore/play.png.asset.json";
const play = play__asset.url;
import norwood3__asset from "@/assets/restore/norwood-3.png.asset.json";
const norwood3 = norwood3__asset.url;
import norwood4__asset from "@/assets/restore/norwood-4.png.asset.json";
const norwood4 = norwood4__asset.url;
import norwood5__asset from "@/assets/restore/norwood-5.png.asset.json";
const norwood5 = norwood5__asset.url;
import norwood6__asset from "@/assets/restore/norwood-6.png.asset.json";
const norwood6 = norwood6__asset.url;

export const LOGO = logo;
export const HERO_IMG = hero;
export const PLAY_BTN = play;

export const navLinks = [
  { label: "No-Shave Procedure", href: "https://restorehair.com/no-shave-fue-hair-transplant/" },
  { label: "Before & Afters", href: "https://restorehair.com/results/" },
  { label: "Pricing", href: "https://restorehair.com/pricing/" },
  { label: "Locations", href: `${BASE}/locations/` },
  { label: "Solutions", href: `${BASE}/no-shave-fue-hair-transplant/` },
  { label: "Elite Team", href: `${BASE}/doctors/` },
  { label: "Learn", href: `${BASE}/considering-hair-restoration/` },
];

export const navDropdowns: Record<string, { label: string; href: string }[]> = {
  Solutions: [
    { label: "No-Shave FUE Hair Transplant", href: `${BASE}/no-shave-fue-hair-transplant/` },
    { label: "Standard FUE Hair Transplant", href: "https://restorehair.com/procedure/" },
    { label: "See How I'd Look With a Hair Transplant", href: "https://restorehair.com/see-how-id-look-with-a-hair-transplant/" },
    { label: "Non-Surgical", href: `${BASE}/non-surgical/` },
    { label: "Hair Restoration for Women", href: `${BASE}/thairapy/` },
  ],
  "Elite Team": [
    { label: "Meet Our Doctors", href: `${BASE}/doctors/` },
    { label: "Dr. James Harris", href: `${BASE}/doctors/dr-james-harris/` },
    { label: "Dr. Adam Cloninger", href: `${BASE}/doctors/dr-adam-cloninger/` },
    { label: "Dr. Shelly Lovitt", href: `${BASE}/doctors/dr-shelly-lovitt/` },
    { label: "Dr. Shadia Saleh", href: `${BASE}/doctors/dr-shadia-saleh/` },
    { label: "Dr. Fahad Juboori", href: `${BASE}/doctors/dr-fahad-juboori/` },
    { label: "Dr. Broc Pratt", href: `${BASE}/doctors/dr-broc-pratt/` },
    { label: "Dr. Anish Patel", href: `${BASE}/doctors/dr-anish-patel/` },
  ],
  Learn: [
    { label: "Why RESTORE", href: `${BASE}/why-restore/` },
    { label: "Reviews", href: `${BASE}/reviews/` },
    { label: "Consultation", href: `${BASE}/what-to-expect-at-your-hair-restoration-consultation/` },
    { label: "Values & Mission", href: `${BASE}/values-mission/` },
    { label: "FAQs", href: `${BASE}/hair-transplant-faqs/` },
    { label: "Blog", href: `${BASE}/hair-loss-blog/` },
    { label: "Media Coverage", href: `${BASE}/media-outlet/` },
  ],
};

// Consolidated quick-quote funnel on the LP site. Every "Get a Quick Quote"
// button goes straight to part 1, which shows the Norwood picker when no class
// was chosen. Norwood head tiles also go to part 1, with the class chosen.
// Do not link to /quick-quote-norwood-page-1/. It is only a redirect, and a
// link to it gives every click a 2-hop redirect chain.
export const LP_BASE = "https://restorehair.com";
export const quickQuoteUrl = `${LP_BASE}/quick-quote-part-1/`;
export const norwoodHeadsUrl = `${LP_BASE}/quick-quote-part-1/`;
export const scheduleUrl = `${BASE}/schedule-a-consult/`;
// Internal scheduling page with the embedded Acuity calendar.
export const scheduleConsultUrl = "/schedule-a-consult/";
export const pricingUrl = `${BASE}/pricing/`;
export const resultsUrl = `${BASE}/results/`;

export const heroVideoUrl = "https://d17ehmrb6zqtjv.cloudfront.net/restore_therestoredifference_v3.1+(1080p)+(1).mp4";

export const norwoodClasses = [
  { label: "Class 3", img: norwood3 },
  { label: "Class 4", img: norwood4 },
  { label: "Class 5", img: norwood5 },
  { label: "Class 6", img: norwood6 },
];

export const footerCols = [
  {
    title: "Solutions",
    links: [
      { label: "FUE Hair Transplant", href: `${BASE}/procedure/` },
      { label: "Non-Surgical Solutions", href: `${BASE}/non-surgical/` },
      { label: "Female Solutions", href: `${BASE}/thairapy/` },
    ],
  },
  {
    title: "Learn",
    links: [
      { label: "What to Expect", href: `${BASE}/what-to-expect-at-your-hair-restoration-consultation/` },
      { label: "FAQs", href: `${BASE}/hair-transplant-faqs/` },
      { label: "Blog", href: `${BASE}/hair-loss-blog/` },
      { label: "Media Coverage", href: `${BASE}/media-outlet/` },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "Why RESTORE", href: `${BASE}/why-restore/` },
      { label: "Reviews", href: `${BASE}/reviews/` },
      { label: "Values & Mission", href: `${BASE}/values-mission/` },
      { label: "Locations", href: `${BASE}/locations/` },
    ],
  },
];
